module.exports = __webpack_public_path__ + "static/media/rocket.5db72815.svg";